import { builder } from '.';
import * as mutations from './mutations';
import { glassBeneficiaryGetter, playerSeeableCardsGetter } from './getters';

const stateGetter = builder.state();

export const gameStore = {
    get state() { return stateGetter(); },
    get glassBeneficiary() { return glassBeneficiaryGetter(); },
    get playerSeeableCards() { return playerSeeableCardsGetter(); },


    ...mutations
}
